import { Link, useLocation } from 'react-router-dom';
import { Briefcase, Menu, ChevronDown } from 'lucide-react';
import { useState } from 'react';

export default function Navbar() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const [seekersOpen, setSeekersOpen] = useState(false);
  const [employersOpen, setEmployersOpen] = useState(false);
  const isActive = (path) => location.pathname === path ? 'active' : '';

  if (location.pathname.startsWith('/admin')) return null;

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        <Link to="/" className="navbar-logo">
          <img src="/logo.png" alt="CareerQuess Logo" className="site-logo" />
        </Link>
        <div className={`navbar-links ${menuOpen ? 'open' : ''}`}>
          <Link to="/" className={isActive('/')}>Home</Link>
          <Link to="/about" className={isActive('/about')}>About Us</Link>

          <div className="nav-dropdown"
            onMouseEnter={() => setServicesOpen(true)}
            onMouseLeave={() => setServicesOpen(false)}>
            <span className={`nav-dropdown-trigger ${['/services/placement', '/services/hr', '/services/manpower'].includes(location.pathname) ? 'active' : ''}`}>
              Our Services <ChevronDown size={14} />
            </span>
            {servicesOpen && (
              <div className="nav-dropdown-menu">
                <Link to="/services/placement" onClick={() => setServicesOpen(false)}>Placement Consultant</Link>
                <Link to="/services/hr" onClick={() => setServicesOpen(false)}>HR Consultant</Link>
                <Link to="/services/manpower" onClick={() => setServicesOpen(false)}>Manpower Recruitment</Link>
              </div>
            )}
          </div>

          <div className="nav-dropdown"
            onMouseEnter={() => setSeekersOpen(true)}
            onMouseLeave={() => setSeekersOpen(false)}>
            <span className={`nav-dropdown-trigger ${['/jobs', '/post-resume'].includes(location.pathname) ? 'active' : ''}`}>
              For Seekers <ChevronDown size={14} />
            </span>
            {seekersOpen && (
              <div className="nav-dropdown-menu">
                <Link to="/jobs" onClick={() => setSeekersOpen(false)}>Current Openings</Link>
                <Link to="/post-resume" onClick={() => setSeekersOpen(false)}>Post Your Resume</Link>
              </div>
            )}
          </div>

          <div className="nav-dropdown"
            onMouseEnter={() => setEmployersOpen(true)}
            onMouseLeave={() => setEmployersOpen(false)}>
            <span className={`nav-dropdown-trigger ${['/employers', '/employer-requirements', '/industry-solutions'].includes(location.pathname) ? 'active' : ''}`}>
              For Employers <ChevronDown size={14} />
            </span>
            {employersOpen && (
              <div className="nav-dropdown-menu">
                <Link to="/employer-requirements" onClick={() => setEmployersOpen(false)}>Employers Requirements</Link>
                <Link to="/employers" onClick={() => setEmployersOpen(false)}>Our Employers</Link>
                <Link to="/industry-solutions" onClick={() => setEmployersOpen(false)}>Industry Solutions</Link>
              </div>
            )}
          </div>

          <Link to="/contact" className={isActive('/contact')}>Contact Us</Link>
        </div>
        <button className="mobile-menu-btn" onClick={() => setMenuOpen(!menuOpen)}>
          <Menu size={24} />
        </button>
      </div>
    </nav>
  );
}
